import styled from "styled-components";

export const StyledWrapper = styled.div`
  height: 196px;
  border-radius: 8px;

  ${({ theme }) => theme.media.exceptMobile`
    height: 108px;
  `}

  ${({ theme }) => theme.media.exceptMobile`
    background-color: ${({ theme }) => theme.colors.neutralsBackgroundInactive};
  `}

  .fixed-top {
    padding-top: 64px;
    background-color: ${({ theme }) => theme.colors.neutralsWhite};
    border-bottom: 2px solid ${({ theme }) => theme.colors.primaryBackground};
    border-radius: 0;

    .contest-actions {
      margin: 0;
      padding: 0 0 16px;

      ${({ theme }) => theme.media.exceptMobile`
        padding-top: 16px;
      `}
    }

    .contest-actions-items {
    }

    .contest-stats {
      padding: 16px 0;
    }
  }

  .contest-actions {
    margin-top: 24px;
    padding: 8px 0 0;
    color: ${({ theme }) => theme.colors.primaryText};
    ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}

    ${({ theme }) => theme.media.exceptMobile`
      margin: 24px 0;
      padding: 0;
      border-top: 2px solid transparent;
    `}

    a {
      color: ${({ theme }) => theme.colors.primaryText};
    }

    .contest-actions-cta {
      text-wrap: nowrap;

      button {
        height: 42px;
        color: ${({ theme }) => theme.colors.neutralsWhite};
        ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}
        border: 0;
      }
    }

    .contest-actions-share {
      text-wrap: nowrap;

      button {
        height: 42px;
        border: 0;
      }
    }
  }

  .contest-stats {
    padding: 24px 0;
    background-color: ${({ theme }) => theme.colors.neutralsBackgroundInactive};
    border-radius: 8px;

    ${({ theme }) => theme.media.exceptMobile`
      background-color: transparent;
    `}

    .contest-stats-divider {
      border-left: 0.5px solid ${({ theme }) => theme.colors.primarySeparator};
    }

    .contest-stats-item {
      .contest-stats-item-label {
        color: ${({ theme }) => theme.colors.neutralsTextLight};
        ${({ theme }) => theme.fontStyles.InterfaceCopyXSmall}
      }

      .contest-stats-item-value {
        color: ${({ theme }) => theme.colors.primaryText};
        ${({ theme }) => theme.fontStyles.DesktopHeadlinesH5}
      }

      .contest-stats-timer {
        &.default {
          .contest-stats-item-value {
            color: ${({ theme }) => theme.colors.primaryText};
          }
        }

        &.warning {
          .contest-stats-item-value {
            color: ${({ theme }) => theme.colors.atRiskBackground};
          }
        }

        &.expired {
          .contest-stats-item-value {
            color: ${({ theme }) => theme.colors.offTrackBackground};
          }
        }
      }
    }
  }
`;
